"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_document_service_client_js_1 = require("@synisys/idm-document-service-client-js");
var Observable_1 = require("rxjs/Observable");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_policy_client_js_1 = require("@synisys/idm-policy-client-js");
var operators_1 = require("rxjs/operators");
var noop_1 = require("rxjs/util/noop");
var http_1 = require("@angular/common/http");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var from_1 = require("rxjs/observable/from");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var empty_1 = require("rxjs/observable/empty");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
require("./user-help-item.component.scss");
var UserHelpItemComponent = /** @class */ (function () {
    function UserHelpItemComponent(documentService, authenticationService, policyService, localeService, classifierService, messageService, deService) {
        this.documentService = documentService;
        this.authenticationService = authenticationService;
        this.policyService = policyService;
        this.localeService = localeService;
        this.classifierService = classifierService;
        this.messageService = messageService;
        this.deService = deService;
        this.deleteUserHelpItem = new core_1.EventEmitter();
    }
    UserHelpItemComponent_1 = UserHelpItemComponent;
    UserHelpItemComponent.correctExtension = function (extension) {
        return extension.toLowerCase().replace(' ', '');
    };
    Object.defineProperty(UserHelpItemComponent.prototype, "documentPresent", {
        get: function () {
            return this._documentPresent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserHelpItemComponent.prototype, "sizeInKB", {
        get: function () {
            return Math.round(+this._documentInfo.size / UserHelpItemComponent_1.KB_IN_BYTES);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserHelpItemComponent.prototype, "validationMessage", {
        get: function () {
            return this._validationMessage;
        },
        set: function (value) {
            this._validationMessage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserHelpItemComponent.prototype, "date", {
        get: function () {
            return this._date;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserHelpItemComponent.prototype, "userName", {
        get: function () {
            return this._userName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserHelpItemComponent.prototype, "documentName", {
        get: function () {
            return this._documentInfo.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserHelpItemComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    UserHelpItemComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._isReady = false;
        if (this.userHelpItem.documentId &&
            this.userHelpItem.documentId !== -1) {
            this.documentService
                .getIsDocumentPresent(this.userHelpItem.documentId)
                .pipe(operators_1.first(), operators_1.tap(function (isPresent) { return _this.setupDocument(isPresent); }))
                .subscribe(noop_1.noop, console.error);
        }
        else {
            this._documentPresent = false;
        }
        this.setupDocumentPolicy();
    };
    UserHelpItemComponent.prototype.onFileChange = function (event) {
        if (event.target.files.length > 0) {
            this._uploadedFile = event.target.files[0];
            this._validationMessage = '';
            this.uploadFile();
        }
    };
    UserHelpItemComponent.prototype.getMessage = function (key) {
        return this.messageService.getMessage(key);
    };
    UserHelpItemComponent.prototype.getAllowedFileExtensionsJoined = function () {
        return this.allowedFileExtensions
            .map(function (extension) {
            return '.'.concat(UserHelpItemComponent_1.correctExtension(extension));
        })
            .join(', ');
    };
    UserHelpItemComponent.prototype.cancelFile = function () {
        this.clearDocumentFields();
    };
    UserHelpItemComponent.prototype.downloadFile = function () {
        var _this = this;
        this.documentService
            .getIsDocumentPresent(this._documentInfo.id)
            .pipe(operators_1.first(), operators_1.tap(function (isConfirmed) {
            if (isConfirmed) {
                _this.deService
                    .getDocumentTokenByDocumentId(_this.categoryName, _this._documentInfo.id)
                    .pipe(operators_1.first(), operators_1.switchMap(function (authInfo) {
                    return _this.documentService.getDownloadUrl(_this._documentInfo.id, authInfo);
                }), operators_1.tap(function (url) {
                    return _this.documentService.downloadDocument(url, idm_document_service_client_js_1.FileType.ORIGINAL);
                }))
                    .subscribe(noop_1.noop, console.error);
            }
            else {
                _this.documentService.downloadTempDocument(_this._documentInfo.id);
            }
        }))
            .subscribe(noop_1.noop, console.error);
    };
    UserHelpItemComponent.prototype.setupDocument = function (isConfirmed) {
        var _this = this;
        (isConfirmed
            ? this.documentService.getDocumentInfo(this.userHelpItem.documentId)
            : this.documentService.getTempDocumentInfo(this.userHelpItem.documentId))
            .pipe(operators_1.first(), operators_1.tap(function (documentInfo) {
            return _this.setDocumentFields(documentInfo);
        }))
            .subscribe(noop_1.noop, console.error);
    };
    UserHelpItemComponent.prototype.setupDocumentPolicy = function () {
        var _this = this;
        this.authenticationService
            .getUserData()
            .pipe(operators_1.first(), operators_1.switchMap(function (userData) {
            return _this.policyService.getUserPolicy(userData.userId, UserHelpItemComponent_1.DOCUMENT_POLICY_KEY);
        }), operators_1.tap(function (policy) {
            var policyOption = JSON.parse(policy.policyOptionParam);
            _this.allowedSize = policyOption['maxSize'];
            _this.allowedFileExtensions =
                UserHelpItemComponent_1.ALLOWED_FILE_EXTENSIONS;
            _this._isReady = true;
        }))
            .subscribe(noop_1.noop, console.error);
    };
    UserHelpItemComponent.prototype.uploadFile = function () {
        var _this = this;
        this.validate()
            .pipe(operators_1.first(), operators_1.tap(function () { return _this.fileUpload(_this._uploadedFile); }))
            .subscribe(noop_1.noop, function (error) {
            _this.clearDocumentFields();
            if (error instanceof http_1.HttpErrorResponse) {
                if (error.status === 400) {
                    if (error.error.hasOwnProperty('type') &&
                        error.error.type === 'EXTENSION') {
                        _this.messageService
                            .getMessageWithPlaceholder('document.service.errors.extension', [error.error.currentExtension])
                            .pipe(operators_1.first(), operators_1.tap(function (message) {
                            return (_this.validationMessage = message);
                        }))
                            .subscribe(noop_1.noop, console.error);
                    }
                    else if (error.error.hasOwnProperty('type') &&
                        error.error.type === 'SIZE') {
                        _this.messageService
                            .getMessageWithPlaceholder('document.service.errors.size', [error.error.currentSize])
                            .pipe(operators_1.first(), operators_1.tap(function (message) {
                            return (_this.validationMessage = message);
                        }))
                            .subscribe(noop_1.noop, console.error);
                    }
                }
                else {
                    _this.validationMessage = error.message;
                }
            }
            else {
                _this.validationMessage = error;
            }
        });
    };
    UserHelpItemComponent.prototype.validate = function () {
        var _this = this;
        if (!this._uploadedFile) {
            return this.messageService
                .getMessage('document.service.errors.no_file')
                .pipe(operators_1.switchMap(function (err) { return Observable_1.Observable.throw(err); }));
        }
        if (this.allowedSize &&
            this._uploadedFile.size >
                this.allowedSize * UserHelpItemComponent_1.MB_IN_BYTES) {
            return this.messageService
                .getMessageWithPlaceholder('document.service.errors.size_validation', [this.allowedSize.toString()])
                .pipe(operators_1.switchMap(function (err) { return Observable_1.Observable.throw(err); }));
        }
        if (!this.allowedFileExtensions
            .map(UserHelpItemComponent_1.correctExtension)
            .some(function (extension) {
            return _this._uploadedFile.name.toLowerCase().endsWith(extension);
        })) {
            return this.messageService
                .getMessageWithPlaceholder('document.service.errors.extension_validation', [this.getAllowedFileExtensionsJoined()])
                .pipe(operators_1.switchMap(function (err) { return Observable_1.Observable.throw(err); }));
        }
        return this.documentService.validate(this._uploadedFile);
    };
    UserHelpItemComponent.prototype.fileUpload = function (file) {
        var _this = this;
        this.documentService
            .upload(this.categoryName, this._uploadedFile.name, file)
            .pipe(operators_1.first(), operators_1.tap(function (documentInfo) {
            return _this.setDocumentFields(documentInfo);
        }))
            .subscribe(noop_1.noop, function (error) {
            if (error.status === 404) {
                if (typeof error.error === 'string' &&
                    error.error.startsWith('Policy')) {
                    _this._validationMessage = error.error;
                }
            }
        });
    };
    UserHelpItemComponent.prototype.setDocumentFields = function (documentInfo) {
        var _this = this;
        this._documentInfo = documentInfo;
        this.userHelpItem.documentId = this._documentInfo.id;
        this._userName = this.classifierService
            .loadClassifier('user', this._documentInfo.userId, false)
            .pipe(operators_1.switchMap(function (classifier) {
            return !classifier || !classifier.getId()
                ? empty_1.empty()
                : _this.classifierService.getEntityName('user', classifier);
        }));
        this._date = from_1.from(this.localeService.formatDate(this._documentInfo.created * 1000, this.currentLanguage.getId()));
        this._size = +this._documentInfo.size;
        this._documentPresent = true;
    };
    UserHelpItemComponent.prototype.clearDocumentFields = function () {
        this._documentPresent = false;
        this.userHelpItem.documentId = undefined;
        this._uploadedFile = undefined;
        this._documentInfo = undefined;
        this._date = undefined;
        this._userName = undefined;
    };
    var UserHelpItemComponent_1;
    UserHelpItemComponent.MB_IN_BYTES = 1048576;
    UserHelpItemComponent.KB_IN_BYTES = 1024;
    UserHelpItemComponent.DOCUMENT_POLICY_KEY = '2c191221-9041-11e6-821f-0050568f767f';
    UserHelpItemComponent.ALLOWED_FILE_EXTENSIONS = [
        'doc',
        'docx',
        'pdf',
        'xls',
    ];
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], UserHelpItemComponent.prototype, "index", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], UserHelpItemComponent.prototype, "userHelpItem", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], UserHelpItemComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], UserHelpItemComponent.prototype, "languages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_crosscutting_concepts_frontend_1.Language)
    ], UserHelpItemComponent.prototype, "currentLanguage", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], UserHelpItemComponent.prototype, "deleteUserHelpItem", void 0);
    UserHelpItemComponent = UserHelpItemComponent_1 = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'user-help-item',
            template: require('./user-help-item.component.html'),
        }),
        __metadata("design:paramtypes", [idm_document_service_client_js_1.DocumentService,
            idm_authentication_client_js_1.AuthenticationService,
            idm_policy_client_js_1.PolicyService,
            idm_locale_service_client_js_1.LocaleService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_message_language_service_client_js_1.MessageService,
            idm_de_service_client_js_1.DeService])
    ], UserHelpItemComponent);
    return UserHelpItemComponent;
}());
exports.UserHelpItemComponent = UserHelpItemComponent;
//# sourceMappingURL=user-help-item.component.js.map